<template>
  <div>
    <div class="modal fade show " id="modalAdicioarCredito" tabindex="-1" role="dialog"
      aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false"
      data-backdrop="static" v-if="showModalConfirmarGravacao">
      <div class="modal-dialog modal">
        <div class="modal-content">
          <div class="modal-body"> 

            <span class="text-center" v-html="mensagemConfirmarGravacao"></span><br>
            
              <div class="success-checkmark">
                <div class="check-icon">
                  <span class="icon-line line-tip"></span>
                  <span class="icon-line line-long"></span>
                  <div class="icon-circle"></div>
                  <div class="icon-fix"></div>
                </div>
              </div>
              <br>
              <span class="text-center" v-html="mensagemConfirmarGravacaoQuantidade"></span>
          </div>
          <div class="modal-footer">
            <a href="#" class="text-danger"  v-on:click="showModalConfirmarGravacao = false"><strong>Fechar</strong></a>
          </div>
        </div>
      </div>
    </div>
    <div class="modal fade fadeIn show " tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" data-keyboard="false" data-backdrop="static" v-if="showModalPonto">
      <div class="modal-dialog modal-md">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <h4>Pontos</h4> <span style="position: absolute; right: 8px; font-size: 20px;" v-on:click="closeModal()"><i class="fas fa-times"></i></span>
              <div class="form-group col-md-12 text-left">
              <label>Descrição</label>
              <input placeholder="Descrição do ponto" class="form-control" type="text" v-model="ponto.descricao"> 
              </div>
              <template v-if="$auth.check('P110')">
              
              <div class="form-group col-md-12 text-left">
                  <label>Cliente:</label><br>
                  <input type="hidden" id="pontoClienteId" v-model="ponto.clienteId" />
                  <buscar-cliente  v-validate="'required'" id="pontoClienteNome" name="pontoClienteNome" :classes="{ input: 'input pula form-control', wrapper: 'input-wrapper'}" :required="true" :errors="errors.has('clienteNome')" v-model="ponto.clienteNomeFantasia" :on-select="setarClientePonto" :on-blur="verificarClientePonto"/>
              </div>
              </template>
              <template v-if="$auth.check('P110')">
              <div class="form-group col-md-12 text-left">
                  <label>Tipo do Ponto</label>
                  <select class="pula form-control custom" v-model="ponto.pontoTipoId">
                  <option v-for="pontoTipo in pontosTipos" selected v-bind:value="pontoTipo.id">{{pontoTipo.descricao}}</option>
                  </select>
              </div>
              </template>

              <div class="form-group col-md-12">
              <button class="btn btn-success btn-block" v-on:click="gravarPonto();"><i v-if="processando" class="fa fa-spinner fa-spin"></i> Gravar Ponto</button>
              </div>
              <hr/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
export default {
  name: '',
  props: {
    showModalPonto: Boolean,
    latitude: Number,
    longitude: Number
  },
  data () {
    return {
      processando: false,
      // showModalPonto: false,
      showModalConfirmarGravacao: false,
      mensagemConfirmarGravacao: '',
      mensagemConfirmarGravacaoQuantidade: '',
      pontosTipos: [],
      ponto: {
        id: '0',
        latitude: '0',
        longitude: '0',
        descricao: '',
        clienteId: '0',
        pontoTipoId: '11'
      }
    }
  },
  mounted () {
    this.buscarPontosTipos()
  },
  methods: {
    buscarPontosTipos: function () {
      var self = this
      var config = {
        headers: {'Authorization': 'Bearer ' + this.$store.state.token}
      }
      var url = '/api/pontosTipos/buscarPontosTipos?busca='
      axios.get(url, config)
      .then(function (response) {
        self.pontosTipos = response.data
      })
    },
    setarClientePonto: function (cliente) {
      this.ponto.clienteId = cliente.id
      this.ponto.clienteNomeFantasia = cliente.nomeFantasia
      $(this.$el).find('#pontoClienteNome').val(cliente.nomeFantasia)
    },
    verificarClientePonto: function () {
      if ($(this.$el).find('#pontoClienteId').val() === '0') {
        this.ponto.clienteId = 0
        this.ponto.clienteNome = ''
        $(this.$el).find('#pontoClienteId').val(0)
        $(this.$el).find('#pontoClienteNome').val('')
      }
      if ($(this.$el).find('#pontoClienteNomePonto').val() === '') {
        this.ponto.clienteId = 0
        this.ponto.clienteNome = ''
        $(this.$el).find('#pontoClienteId').val(0)
        $(this.$el).find('#pontoClienteNome').val('')
      }
    },
    gravarPonto () {
      let self = this
      console.log('Gravar lati ' + self.latitude)
        // if (self.markers.length === 0) {
        //   this.$toastr('error', 'Adicione um ponto de referência ao mapa.', 'Atenção')
        //   return
        // }
        // if (self.markers.length > 1) {
        //   this.$toastr('error', 'Adicione APENAS UM ponto de referência ao mapa.', 'Atenção')
        //   return
        // }
      if (self.ponto.descricao === '') {
        this.$toastr('error', 'Adicione a descrição do ponto.', 'Atenção')
        return
      }
      self.ponto.latitude = self.latitude
      self.ponto.longitude = self.longitude
      self.processando = true
      let config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      }
      let url = '/api/pontos/salvar'
      axios.post(url, JSON.stringify(self.ponto), config)
      .then(function (response) {
        console.log(response)
        if (response.data === 'OK') {
          self.processando = false
          self.mensagemConfirmarGravacao = '<h2>Parabéns<h2><h4>Ponto gravado com sucesso!</h4><br/>'
          self.mensagemConfirmarGravacaoQuantidade = '<p>Restam <strong>0</strong> pontos para cadastro</p>'
          self.showModalConfirmarGravacao = true
          self.closeModal()
          self.ponto = {id: '0', latitude: '0', longitude: '0', descricao: '', clienteId: '0', pontoTipoId: '0'}
        }
      })
      .catch(function (error) {
        self.processando = false
        console.log(error)
      })
    },
    closeModal () {
      this.showModalPonto = false
      this.$emit('showModalPonto', false)
      this.$emit('eventname', false)
    }
  }
}
</script>
}


// WEBPACK FOOTER //
// src/components/views/relatorios/PontoCadastro.vue